import axios from "../erp/configAxiosClient";

export const postToCreateClient = async (requestData) => {
    return await axios.post(`create/`, requestData)
}